/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const categoriesStrings = pickLocale(ar.categoriesStrings, en.categoriesStrings)
export const categoryWizard = pickLocale(ar.categoryWizard, en.categoryWizard)
export const questionsStrings = pickLocale(ar.questionsStrings, en.questionsStrings)
export const certificatesStrings = pickLocale(ar.certificatesStrings, en.certificatesStrings)
